__turbopack_context__.v({
  "actionActiveColor": "styles-module__0upRNa__actionActiveColor",
  "active": "styles-module__0upRNa__active",
  "colorInput": "styles-module__0upRNa__colorInput",
  "colorPopup": "styles-module__0upRNa__colorPopup",
  "customizer": "styles-module__0upRNa__customizer",
  "customizerBody": "styles-module__0upRNa__customizerBody",
  "customizerTitle": "styles-module__0upRNa__customizerTitle",
  "dotStyles": "styles-module__0upRNa__dotStyles",
  "header": "styles-module__0upRNa__header",
  "hr": "styles-module__0upRNa__hr",
  "itemLabel": "styles-module__0upRNa__itemLabel",
  "itemWrapper": "styles-module__0upRNa__itemWrapper",
  "modeWrapper": "styles-module__0upRNa__modeWrapper",
  "primaryColor": "styles-module__0upRNa__primaryColor",
  "primaryColorWrapper": "styles-module__0upRNa__primaryColorWrapper",
  "show": "styles-module__0upRNa__show",
  "smallScreen": "styles-module__0upRNa__smallScreen",
  "toggler": "styles-module__0upRNa__toggler",
});
